import { markdownToMdAST } from "@genexus/markdown-parser";
import { nothing } from "lit";
import { clearLinkDefinitions } from "./link-resolver";
export const LAST_NESTED_CHILD_CLASS = "last-nested-child";
const findLastNestedChild = (elementWithChildren) => {
    const lastChild = elementWithChildren.children.at(-1);
    // When rendering special values like "\n\n" or "\r\n", the root has no
    // children
    if (lastChild === undefined) {
        return elementWithChildren;
    }
    // The last element have children. We must check its sub children
    if (lastChild.children?.length > 0) {
        return findLastNestedChild(lastChild);
    }
    if (lastChild.type === "code" || lastChild.type === "html") {
        return lastChild;
    }
    return elementWithChildren;
};
export const markdownToJSX = async (markdown, metadata, extensions, renderChildren) => {
    const mdAST = markdownToMdAST(markdown, extensions?.map(extension => extension.tokenizer), extensions?.map(extension => extension.tokensToMdast));
    // First, find the last nested child. Useful to set a marker in the element
    // that accomplish this condition
    const lastNestedChild = findLastNestedChild(mdAST);
    const isLastNestedChild = element => element === lastNestedChild;
    const getAdditionalClasses = element => (isLastNestedChild(element) ? LAST_NESTED_CHILD_CLASS : nothing);
    // Render the markdown as TemplateResult
    const JSX = await renderChildren(mdAST, metadata, {
        isLastNestedChild,
        getAdditionalClasses,
        renderChildren
    });
    // Clear all definitions used to render the current markdown, so the next
    // render does not have old information
    // TODO: These definitions should by shared in the metadata object of the
    // renders, instead of being a global state
    clearLinkDefinitions();
    return JSX;
};
